// extracted by mini-css-extract-plugin
export default {"container":"ServiceDataTab_container__ddIqk","block":"ServiceDataTab_block__CUxK2","serviceData":"ServiceDataTab_serviceData__DCx-0"};